

// Change the colour of nav bar when scroll past certain point 

// get the id of the element you want the nav to change colour on 
var changePoint = document.getElementById("navbar-target");
var changePointActive = changePoint.offsetTop;

//console.log(changePointActive + "this worked");

// When the user scrolls the page, execute myFunction
window.onscroll = function () {
    myFunction()
    // subMenuSticky()
};



// Get the header
var header = document.getElementById("stickynav");

// Get the offset position of the navbar
var sticky = header.offsetTop;
//console.log("hello" + sticky);

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
    var width = jQuery(window).width();

    // console.log(window.pageYOffset);
    if (window.pageYOffset > sticky) {

        header.classList.add("sticky");

    } else {

        if (width > 1200) {
            jQuery(".hoverSubMenu").removeClass("stickySub");
        }

        header.classList.remove("sticky");
        //console.log('removing stickySub to showSubMenu (greater than changePointActive)');

    }

    if (window.pageYOffset > changePointActive) {
        if (width > 1200) {
            jQuery(".hoverSubMenu").addClass("stickySub");
        }
        header.classList.add("stickyScroll");
        //console.log('adding stickySub to showSubMenu (greater than changePointActive)');

    } else {
        if (width > 1200) {
            jQuery(".hoverSubMenu").removeClass("stickySub");
        }
        header.classList.remove("stickyScroll");
        //console.log('removing stickySub to showSubMenu (greater than changePointActive)');
    }
}




jQuery(".company-show").click(function () {

    jQuery(".company-show-me").toggleClass("d-flex");
    console.log("removed");

});




jQuery('.dropdown:eq(0)').hover(function () {
    jQuery(".dropdown-menu:eq(0)").toggleClass("show1");


});

jQuery('.dropdown:eq(1)').hover(function () {
    jQuery(".dropdown-menu:eq(1)").toggleClass("show1");


});

jQuery('.dropdown:eq(2)').hover(function () {
    jQuery(".dropdown-menu:eq(2)").toggleClass("show1");



});

jQuery('.dropdown:eq(3)').hover(function () {
    jQuery(".dropdown-menu:eq(3)").toggleClass("show1");


});

jQuery('.dropdown:eq(4)').hover(function () {
    jQuery(".dropdown-menu:eq(4)").toggleClass("show1");


});

jQuery('.dropdown:eq(5)').hover(function () {
    jQuery(".dropdown-menu:eq(5)").toggleClass("show1");


});

jQuery('.dropdown:eq(6)').hover(function () {
    jQuery(".dropdown-menu:eq(6)").toggleClass("show1");


});

jQuery('.dropdown:eq(7)').hover(function () {
    jQuery(".dropdown-menu:eq(7)").toggleClass("show1");


});

jQuery('.dropdown:eq(8)').hover(function () {
    jQuery(".dropdown-menu:eq(8)").toggleClass("show1");


});
jQuery('.dropdown:eq(9)').hover(function () {
    jQuery(".dropdown-menu:eq(9)").toggleClass("show1");


});
jQuery('.dropdown:eq(10)').hover(function () {
    jQuery(".dropdown-menu:eq(10)").toggleClass("show1");


});
jQuery('.dropdown:eq(11)').hover(function () {
    jQuery(".dropdown-menu:eq(11)").toggleClass("show1");


});
jQuery('.dropdown:eq(12)').hover(function () {
    jQuery(".dropdown-menu:eq(12)").toggleClass("show1");


});



const dropDownLinks = document.querySelectorAll('a.dropdown-menu');

dropDownLinks.forEach(link => {
    link.addEventListener('click', function () {
        if (this.classList.contains('show1')) {
            // If the clicked link already has the 'show1' class, do nothing.
            return;
        }

        // Otherwise, remove the 'show1' class from all other links.
        dropDownLinks.forEach(otherLink => {
            if (otherLink !== this && otherLink.classList.contains('show1')) {
                otherLink.classList.remove('show1');
            }
        });

        // Finally, add the 'show1' class to the clicked link.
        this.classList.add('show1');
    });
});

jQuery('a.dropdown-toggle').on('click', function(e){
    if(jQuery(window).width() < 1199) {
        e.preventDefault();
    }
    
    jQuery(this).siblings('.dropdown-menu').toggleClass('show');
    jQuery(this).siblings('.fa-chevron-right').toggleClass('rotate');
    /* jQuery(this).toggleClass('opened'); */
});


///REMOVE THIS WHEN GOING LIVE
////////////
//////

/* jQuery('a').on('click', function(e) {
    e.preventDefault();
}); */

//////
//////
//////

//////

//////




// var window_size = window.matchMedia('(max-width: 768px)');

// if (window.matchMedia('(max-width: 768px)').matches) {
//     jQuery('.dropdown:first').hover(function () {
//         jQuery(".dropdown-menu:first").toggleClass("show");


//     });

//     jQuery('.dropdown:last').hover(function () {
//         jQuery(".dropdown-menu:last").toggleClass("show");

//     });
// }






// jQuery('.dropdown').hover(function () {
//     if (jQuery("dropdownmenu:first")) {
//     jQuery(".dropdown-menu:first").toggleClass("show");
//     } elseif (jQuery("dropdownmenu:last")) {
//             jQuery(".dropdown-menu:last").toggleClass("show");
//         }
//     }
// );

// document.getElementsByClassName("dropdown-menu")[0].addEventListener("mouseover", function(e) {
//     const parent = e.target.parentElement;
//     if (parent && parent.tagName === "LI" && parent.classList.contains("dropdown-item")) {
//         const parent = e.target.parentElement;
//         parent.children[1].classList.add("show");
//     }
// });

// document.getElementsByClassName("dropdown-menu")[0].addEventListener("mouseout", function(e) {
//     e.target.classList.remove("show");
// });

jQuery(window).scroll(function () {
    jQuery(".slideanim").each(function () {
        var pos = jQuery(this).offset().top;

        var winTop = jQuery(window).scrollTop();
        if (pos < winTop + 800) {
            jQuery(this).addClass("slide1");
        }
    });
});

function carouselScroll() {

    const boxSlider = document.getElementById('scrollingWrapper');

    boxSlider.scroll({
        left: boxSlider.scrollLeft + 250,
        behavior: 'smooth'
    });

}
//Partners slick slider
jQuery(document).ready(function () {
    jQuery('.partners-slider').slick({
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    autoplay: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                }
            }
        ]
    });
});


// Added by Mikey 

function handleMenu() {
    //console.log('handling menu');

    var width = jQuery(window).width();
    if (width > 1200) {
        jQuery(document).on('click', 'ul.navbar-nav > li.item-219', function (e) {
            // e.preventDefault();
            // jQuery('.hoverSubMenu').removeClass('showSubMenu');
            // jQuery("#submenu295").addClass('showSubMenu');
            // jQuery("main").addClass('darken');
            // jQuery('.dropdown-menu').addClass('d-none');

        }).on('mouseenter', 'ul.navbar-nav > li.item-219', function (e) {

            e.preventDefault();
            jQuery('.item-219 > .dropdown-menu').addClass('d-none');
            jQuery('.hoverSubMenu').removeClass('showSubMenu');
            jQuery("#submenu295").addClass('showSubMenu');
            jQuery("main").addClass('darken');



            //jQuery(".item-219 .dropdown-menu").addclass("d-none");
        }).on('mouseleave', '.navbar', function (e) {
            jQuery('.dropdown-menu').removeClass('d-none');
        }).on('mouseenter', 'main', function () {
            jQuery('.hoverSubMenu').removeClass('showSubMenu');
            jQuery("main").removeClass('darken');
        }).on('mouseenter', 'a.logo', function () {
            jQuery('.hoverSubMenu').removeClass('showSubMenu');
            jQuery("main").removeClass('darken');
        })
            .on('mouseenter', '.item-10', function () {
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("main").removeClass('darken');
            })
            .on('mouseenter', '.nav-banner', function () {
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("main").removeClass('darken');
            })

            .on('mouseenter', '.nav-status', function () {
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("main").removeClass('darken');
            })
            .on('mouseenter', '.menu-207', function () {
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("main").removeClass('darken');
            })
            .on('mouseenter', '.menu-172', function () {
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("main").removeClass('darken');
            })
            .on('mouseenter', '.menu-138', function () {
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("main").removeClass('darken');
            })
            .on('click', '.item-', function (e) {
                e.preventDefault();
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("#submenu215").addClass('showSubMenu');
                jQuery("main").addClass('darken');
            })
            .on('mouseenter', '.item-', function (e) {
                e.preventDefault();
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("#submenu215").addClass('showSubMenu');
                jQuery("main").addClass('darken');
            })
            .on('mouseenter', '.btn-nav', function () {
                jQuery('.hoverSubMenu').removeClass('showSubMenu');
                jQuery("main").removeClass('darken');
            })



        // make the top dropdown menu item clickable on big screen sizes 

        jQuery(".item-10").click(function () {
            window.location.href = aboutURL;
        });


    } else {
        jQuery(document).off('mouseenter');
    }




}

jQuery(document).ready(function () {
    handleMenu();

    jQuery(window).resize(function () {
        handleMenu();
    });

    jQuery("#mobileNav li.parent.deeper > a, #mobileNav li.parent.deeper > span.nav-header").click(function (e) {
        e.preventDefault();
        var submenu = jQuery(this).siblings('ul.nav-child');
        jQuery(submenu).toggle();
        jQuery(submenu).parent().toggleClass('showing');

    });

    jQuery(".trustpoints a.request-a-bespoke-quote").click(function (e) {
        e.preventDefault();
        jQuery('#enquireModal').modal('show');
    });

});




function closeMenu() {
    jQuery('.hoverSubMenu').removeClass('showSubMenu');
    jQuery("main").removeClass('darken');
}



// jQuery(document).ready(function () {
//     jQuery("#mapbtn").click(function () {
//         jQuery('html, body').animate({
//             scrollTop: jQuery("#mapbtn").offset().top - jQuery("#stickynav").outerHeight() - 100
//         }, 0);
//     });
// });



// jQuery(document).ready(function () {
//     jQuery("#mapbtnhotel").click(function () {
//         jQuery('html, body').animate({
//             scrollTop: jQuery("#map").offset().top - jQuery("#stickynav").outerHeight() - 100
//         }, 0);
//     });
// });

// logic for resort level map button click scroll 

jQuery(document).ready(function () {
    jQuery("#mapbtn").click(function (e) {
        e.preventDefault(); // Prevent default link behavior

        var targetOffset = jQuery("#mapbtn").offset().top - jQuery("#stickynav").outerHeight() - 100;

        jQuery('html, body').stop().animate({
            scrollTop: targetOffset
        }, 500); // Adjust the duration as needed
    });
});

// similar logic for the hotel view map button 
jQuery(document).ready(function () {
    jQuery("#mapbtnhotel").click(function (e) {
        e.preventDefault(); // Prevent default link behavior

        var targetOffset = jQuery("#map").offset().top - jQuery("#stickynav").outerHeight() - 100;

        jQuery('html, body').stop().animate({
            scrollTop: targetOffset
        }, 500); // Adjust the duration as needed
    });
});


// similar logic for the country page 

jQuery(document).ready(function () {
    jQuery("#mapbtncountry").click(function () {
        jQuery('html, body').animate({
            scrollTop: jQuery("#map").offset().top - jQuery("#stickynav").outerHeight() - 100
        }, 0);
    });
});



// this function makes the filters on the review pages work

jQuery(document).ready(function () {
    // defining the form variable 
    var countrySelect = jQuery('#country-select-review');
    // this checks session storage for the previously selected option - if there's nothing in the it will default to all option see logic below 
    var previousValue = sessionStorage.getItem('selectedCountry');

    if (!previousValue) {
        previousValue = 'all'; // Set a default value here
        sessionStorage.setItem('selectedCountry', previousValue); // Store the default value in session storage
    }

    // gets the previously selected option 
    countrySelect.val(previousValue);

    // listens for a change on the form and goes to the selected url 
    countrySelect.on('change', function () {
        var selectedOption = jQuery(this).find('option:selected');
        var url = selectedOption.data('url');
        var selectedValue = selectedOption.val();

        if (url) {
            sessionStorage.setItem('selectedCountry', selectedValue);
            window.location.href = url;
        }
    });
});



jQuery(document).ready(function () {
    jQuery('#pisteDisplayBtn').on('click', function () {
        var imgLink = jQuery('#pisteDisplay');

        imgLink.trigger('click');

    });
});



jQuery(document).ready(function () {
    jQuery('[data-fancybox="gallery"]').fancybox({
        buttons: ['zoom', 'close'], // Enable zoom and close buttons
        loop: true // Enable looping through the gallery
    });
});

jQuery(document).ready(function () {
    // Add the "checked" class and set the value to 1 when the checkbox is checked
    jQuery('#form1_newsletter_0').on('change', function () {
        if (jQuery(this).is(':checked')) {
            jQuery(this).addClass('checked');
            jQuery(this).val(1);
        } else {
            jQuery(this).removeClass('checked');
            jQuery(this).val(0);
        }
    });

    // Check if the "checked" class is already present and set the value accordingly
    if (jQuery('#form1_newsletter_0').hasClass('checked')) {
        jQuery('#form1_newsletter_0').val(1);
    }

    jQuery('#form1_mobile-contact_0').on('change', function () {
        if (jQuery(this).is(':checked')) {
            jQuery(this).addClass('checked');
            jQuery(this).val(1);
        } else {
            jQuery(this).removeClass('checked');
            jQuery(this).val(0);
        }
    });

    // Check if the "checked" class is already present and set the value accordingly
    if (jQuery('#form1_mobile-contact_0').hasClass('checked')) {
        jQuery('#form1_mobile-contact_0').val(1);
    }
});

function sendQuoteEnquiry(root, formData) {

    request = {};
    request.customerFirstName = formData.get('cf[name]');
    request.customerSurname = formData.get('cf[surname]');
    request.customerEmail = formData.get('cf[email]');
    request.customerNumber = formData.get('cf[number]');
    request.customerQuery = formData.get('cf[message]');
    request.resortTitle = formData.get('resortTitle');
    request.resortLink = formData.get('resortLink');
    request.session = formData.get('session');
    request.newsletter = formData.get('cf[newsletter][]');
    if(request.newsletter == null){
        request.newsletter = '0';
    }
    else {
        request.newsletter = '1';
    }

    grecaptcha.ready(function () {
        grecaptcha.execute('6LfrgAErAAAAACWmj5sy7vi1ww5db51-rZ1Uepq5', { action: 'submit' }).then(function (token) {
            request.reCaptchaResponse = token;

            const API = root + 'index.php?option=com_holco&task=traveljet.addCustomer&tmpl=blank';

           /*  console.log('Sending request to:', API);
            console.log('Request:', request); */

            jQuery.getJSON(API, request).done(function (data) {
                /* console.log('addCustomer Response:', data); */
                if (data.outcome === 'success') {
                    /* console.log('submitting form'); */
                }
            }).fail(function (jqxhr, textStatus, error) {
                const err = textStatus + ", " + error;
                console.error('Request failed:', err);
                console.error(jqxhr.responseText); 
            });
        });
    });

}

function handleAgent(event, origin) {
    return new Promise((resolve) => {
        console.log('Adding agent to database');
        
        const formData = {};
        $('input[name^="cf["]').each(function() {
            const fullName = $(this).attr('name');
            const match = fullName.match(/cf\[([^\]]+)\]/);
            if (match && match[1]) {
                formData[match[1]] = $(this).val();
            }
        });
    
        const API = origin + 'index.php?option=com_holco&task=traveljet.handleAgent&tmpl=raw&'+tkn+'=1';
        const request = { details: formData };
    
        console.log('handleAgent request:', request);
    
        // Using getJSON as requested
        jQuery.getJSON(API, request)
            .done(function(response) {
                console.log('Agent added successfully:', response);
                resolve({ status: 'success', data: response });
            })
            .fail(function(jqXHR, textStatus, errorThrown) {
                console.error('Error adding agent:', textStatus, errorThrown);
                console.log('Response text:', jqXHR.responseText);
                resolve({ 
                    status: 'error', 
                    message: 'Failed to add agent',
                    details: errorThrown
                });
            });
    });
}

// GCLID / FBCLID capture for Convert Forms hidden fields
(function() {
    function getParam(name) {
        var url = window.location.search;
        var regex = new RegExp('[?&]' + name + '=([^&#]*)');
        var results = regex.exec(url);
        return results ? decodeURIComponent(results[1]) : null;
    }

    function setCookie(name, value, days) {
        var expires = '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
    }

    function getCookie(name) {
        var nameEQ = name + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
        }
        return null;
    }

    var gclid = getParam('gclid');
    var fbclid = getParam('fbclid');
    if (gclid) setCookie('gclid', gclid, 90);
    if (fbclid) setCookie('fbclid', fbclid, 90);

    document.addEventListener('DOMContentLoaded', function() {
        var gclidVal = getCookie('gclid');
        var fbclidVal = getCookie('fbclid');

        document.querySelectorAll('input[name="cf[gclid]"]').forEach(function(el) {
            el.value = gclidVal || '';
        });
        document.querySelectorAll('input[name="cf[fbclid]"]').forEach(function(el) {
            el.value = fbclidVal || '';
        });
    });
})();

  